import acceptTenant from './acceptTenant';
import activateUser from './activateUser';
import addFavoriteListing from './addFavoriteListing';
import addListingExclusions from './addListingExclusions';
import addPaymentMethod from './addPaymentMethod';
import addYoutubeVideo from './addYoutubeVideo';
import cancelConversation from './cancelConversation';
import changeConversationDate from './changeConversationDate';
import chargeTenant from './chargeTenant';
import confirmPayoutMethod from './confirmPayoutMethod';
import confirmUser from './confirmUser';
import createBookingRequest from './createBookingRequest';
import createBookingRequestSCA from './createBookingRequestSCA';
import createConversation from './createConversation';
import createListing from './createListing';
import createMakeCall from './createMakeCall';
import createPayment from './createPayment';
import createPaymentSCA from './createPaymentSCA';
import declineConversation from './declineConversation';
import deleteListing from './deleteListing';
import deleteListingPhoto from './deleteListingPhoto';
import deleteListingVideo from './deleteListingVideo';
import deleteListingVideos from './deleteListingVideos';
import deletePaymentMethod from './deletePaymentMethod';
import deleteUser from './deleteUser';
import duplicateListing from './duplicateListing';
import facebookLogin from './facebookLogin';
import generateListingClick from './generateListingClick';
import getBillingInformation from './getBillingInformation';
import getBookablePeriods from './getBookablePeriods';
import getCitiesNearby from './getCitiesNearby';
import getConversation from './getConversation';
import getConversationByToken from './getConversationByToken';
import getConversationCounters from './getConversationCounters';
import getConversationMessages from './getConversationMessages';
import getConversationPayoutInfo from './getConversationPayoutInfo';
import getConversations from './getConversations';
import getCurrencyEuroRates from './getCurrencyEuroRates';
import getFavoriteListings from './getFavoriteListings';
import getFullUrl from './getFullUrl';
import getGlobalCounters from './getGlobalCounters';
import getInvoices from './getInvoices';
import getListingById from './getListingById';
import getListingExclusions from './getListingExclusions';
import getListingPhotos from './getListingPhotos';
import getListingVideos from './getListingVideos';
import getListings from './getListings';
import getListingsSummary from './getListingsSummary';
import getPartner from './getPartner';
import getPartnerClicks from './getPartnerClicks';
import getPartnerPayments from './getPartnerPayments';
import getPaymentMethods from './getPaymentMethods';
import getPaymentMethodsParams from './getPaymentMethodsParams';
import getPaymentParameters from './getPaymentParameters';
import getPois from './getPois';
import getRealtimeToken from './getRealtimeToken';
import getSavedSearches from './getSavedSearches';
import getSearchAlert from './getSearchAlert';
import getSearchAlerts from './getSearchAlerts';
import getSitemaps from './getSitemaps';
import getTransactionHistory from './transactionHistory';
import getUniversities from './getUniversities';
import getUser from './getUser';
import getUserInformation from './getUserInformation';
import getUsers from './getUsers';
import getUserSubscriptions from './getUserSubscriptions';
import googleLogin from './googleLogin';
import hideListing from './hideListing';
import impersonateUser from './impersonateUser';
import initSCAPaymentMethod from './initSCAPaymentMethod';
import login from './login';
import logout from './logout';
import makeSpecialOffer from './makeSpecialOffer';
import markConversationAsRead from './markConversationAsRead';
import recoverAccount from './recoverAccount';
import register from './register';
import registerListingClick from './registerListingClick';
import removeFavoriteListing from './removeFavoriteListing';
import removeSavedSearch from './removeSavedSearch';
import removeSearchAlert from './removeSearchAlert';
import replacesListingExclusions from './replacesListingExclusions';
import reportUser from './reportUser';
import requestActivationEmail from './requestActivationEmail';
import requestCode from './requestCode';
import resetPassword from './resetPassword';
import rotateListingPhoto from './rotateListingPhoto';
import saveSearch from './saveSearch';
import searchCity from './searchCity';
import sendContactRequest from './sendContactRequest';
import sendMessage from './sendMessage';
import showListing from './showListing';
import toggleArchiveConversation from './toggleArchiveConversation';
import toggleFavoriteConversation from './toggleFavoriteConversation';
import translateListingDescription from './translateListingDescription';
import updateBillingInformation from './updateBillingInformation';
import updateListingPhotosOrder from './updateListingPhotosOrder';
import updateUser from './updateUser';
import updateUserSubscriptions from './updateUserSubscriptions';
import uploadAvatarByUrl from './uploadAvatarByUrl';
import upsertSearchAlert from './upsertSearchAlert';
import verifyCode from './verifyCode';
import verifyManually from './verifyManually';
import { City, PayoutMethods } from './types';

interface FetchClient {
  fetch: (url: string, options: RequestInit) => Promise<Response>;
}

export default (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    acceptTenant: acceptTenant(makeCall),
    activateUser: activateUser(makeCall),
    addFavoriteListing: addFavoriteListing(makeCall),
    addListingExclusions: addListingExclusions(makeCall),
    addPaymentMethod: addPaymentMethod(makeCall),
    addYoutubeVideo: addYoutubeVideo(makeCall),
    cancelConversation: cancelConversation(makeCall),
    changeConversationDate: changeConversationDate(makeCall),
    chargeTenant: chargeTenant(makeCall),
    confirmPayoutMethod: confirmPayoutMethod(makeCall),
    confirmUser: confirmUser(makeCall),
    createBookingRequest: createBookingRequest(makeCall),
    createBookingRequestSCA: createBookingRequestSCA(makeCall),
    createConversation: createConversation(makeCall),
    createListing: createListing(makeCall),
    createPayment: createPayment(makeCall),
    createPaymentSCA: createPaymentSCA(makeCall),
    declineConversation: declineConversation(makeCall),
    deleteListing: deleteListing(makeCall),
    deleteListingPhoto: deleteListingPhoto(makeCall),
    deleteListingVideo: deleteListingVideo(makeCall),
    deleteListingVideos: deleteListingVideos(makeCall),
    deletePaymentMethod: deletePaymentMethod(makeCall),
    deleteUser: deleteUser(makeCall),
    duplicateListing: duplicateListing(makeCall),
    facebookLogin: facebookLogin(makeCall),
    generateListingClick: generateListingClick(makeCall),
    getBillingInformation: getBillingInformation(makeCall),
    getBookablePeriods: getBookablePeriods(makeCall),
    getCitiesNearby: getCitiesNearby(makeCall),
    getConversation: getConversation(makeCall),
    getConversationByToken: getConversationByToken(makeCall),
    getConversationCounters: getConversationCounters(makeCall),
    getConversationMessages: getConversationMessages(makeCall),
    getConversationPayoutInfo: getConversationPayoutInfo(makeCall),
    getConversations: getConversations(makeCall),
    getCurrencyEuroRates: getCurrencyEuroRates(makeCall),
    getFavoriteListings: getFavoriteListings(makeCall),
    getFullUrl: getFullUrl(makeCall),
    getGlobalCounters: getGlobalCounters(makeCall),
    getInvoices: getInvoices(makeCall),
    getListingById: getListingById(makeCall),
    getListingExclusions: getListingExclusions(makeCall),
    getListingPhotos: getListingPhotos(makeCall),
    getListingVideos: getListingVideos(makeCall),
    getListings: getListings(makeCall),
    getListingsSummary: getListingsSummary(makeCall),
    getPartner: getPartner(makeCall),
    getPartnerClicks: getPartnerClicks(makeCall),
    getPartnerPayments: getPartnerPayments(makeCall),
    getPaymentMethods: getPaymentMethods(makeCall),
    getPaymentMethodsParams: getPaymentMethodsParams(makeCall),
    getPaymentParameters: getPaymentParameters(makeCall),
    getPois: getPois(makeCall),
    getRealtimeToken: getRealtimeToken(makeCall),
    getSavedSearches: getSavedSearches(makeCall),
    getSearchAlert: getSearchAlert(makeCall),
    getSearchAlerts: getSearchAlerts(makeCall),
    getSitemaps: getSitemaps(makeCall),
    getTransactionHistory: getTransactionHistory(makeCall),
    getUniversities: getUniversities(makeCall),
    getUser: getUser(makeCall),
    getUserInformation: getUserInformation(makeCall),
    getUsers: getUsers(makeCall),
    getUserSubscriptions: getUserSubscriptions(makeCall),
    googleLogin: googleLogin(makeCall),
    hideListing: hideListing(makeCall),
    impersonateUser: impersonateUser(makeCall),
    initSCAPaymentMethod: initSCAPaymentMethod(makeCall),
    login: login(makeCall),
    logout: logout(makeCall),
    makeSpecialOffer: makeSpecialOffer(makeCall),
    markConversationAsRead: markConversationAsRead(makeCall),
    recoverAccount: recoverAccount(makeCall),
    register: register(makeCall),
    registerListingClick: registerListingClick(makeCall),
    removeFavoriteListing: removeFavoriteListing(makeCall),
    removeSavedSearch: removeSavedSearch(makeCall),
    removeSearchAlert: removeSearchAlert(makeCall),
    replacesListingExclusions: replacesListingExclusions(makeCall),
    reportUser: reportUser(makeCall),
    requestActivationEmail: requestActivationEmail(makeCall),
    requestCode: requestCode(makeCall),
    resetPassword: resetPassword(makeCall),
    rotateListingPhoto: rotateListingPhoto(makeCall),
    saveSearch: saveSearch(makeCall),
    searchCity: searchCity(makeCall),
    sendContactRequest: sendContactRequest(makeCall),
    sendMessage: sendMessage(makeCall),
    showListing: showListing(makeCall),
    toggleArchiveConversation: toggleArchiveConversation(makeCall),
    toggleFavoriteConversation: toggleFavoriteConversation(makeCall),
    translateListingDescription: translateListingDescription(makeCall),
    updateBillingInformation: updateBillingInformation(makeCall),
    updateListingPhotosOrder: updateListingPhotosOrder(makeCall),
    updateUser: updateUser(makeCall),
    updateUserSubscriptions: updateUserSubscriptions(makeCall),
    uploadAvatarByUrl: uploadAvatarByUrl(makeCall),
    upsertSearchAlert: upsertSearchAlert(makeCall),
    verifyCode: verifyCode(makeCall),
    verifyManually: verifyManually(makeCall),
    getFeaturedCities: (query: { exclude: string }) =>
      makeCall('GET', '/api/v2/geonames/cities/featured', {
        query,
      }),
    getCities: (data: {
      list: Array<{ query: string }>;
      languages: string[];
    }) =>
      makeCall<{ [key: string]: City[] }>(
        'POST',
        '/api/v2/geonames/search-city-multiple',
        { data },
      ),
    validatePhone: (data: { countryCode: string; phone: string }) =>
      makeCall('POST', '/api/v2/validation/phone', {
        data,
      }),
    addSavedSearch: (userId: 'me' | number, data: {}) =>
      makeCall('POST', `/api/v2/user/${userId}/search`, {
        data,
      }),
    addPoiDraft: (data: {
      city: string;
      countryCode: string;
      description: string;
      name: string;
    }) =>
      makeCall('POST', `/api/v2/poi`, {
        data,
      }),
    /** @swagger /#api-Default-userUserIdPayoutMethodsGet */
    getPayoutMethods: () =>
      makeCall<PayoutMethods>('GET', `/api/v2/user/me/payout-methods`),
    /** @swagger /#api-Default-userUserIdPayoutMethodsSetDefaultPut */
    setPayoutMethodAsDefault: (methodId: number) =>
      makeCall('PUT', `/api/v2/user/me/payout-methods/set-default`, {
        data: { defaultMethodId: methodId },
      }),
    sendTalkPageFile: ({
      conversationId,
      file,
    }: {
      conversationId: number;
      file: string;
    }) =>
      makeCall('PUT', `/api/v2/conversation/${conversationId}/attachment`, {
        data: { attachmentFile: file },
        headers: {
          'Content-Type': 'multipart/form-data; boundary=%s',
        },
        query: { expand: 'messages' },
      }),
    /** @swagger /#api-Default-userUserIdPayoutMethodPost */
    addPayoutMethod: (data: {
      accountNumber: string;
      beneficiaryName: string;
      code: string;
      country: string;
      currency: string;
      homeAddress: string;
      iban: string;
      ownerName: string;
      paypalEmail: string;
      type: 'iban' | 'paypal' | 'bank';
    }) =>
      makeCall('POST', `/api/v2/user/me/payout-method`, {
        data,
      }),
    /** @swagger /#api-Default-userUserIdPayoutMethodPayoutMethodIdGet */
    getPayoutMethod: (methodId: number) =>
      makeCall('GET', `/api/v2/user/me/payout-method/${methodId}`),
    /** @swagger /#api-Default-userUserIdPayoutMethodPayoutMethodIdPut */
    updatePayoutMethod: (
      methodId: number,
      data: {
        accountNumber: string;
        beneficiaryName: string;
        code: string;
        country: string;
        currency: string;
        homeAddress: string;
        iban: string;
        ownerName: string;
        paypalEmail: string;
        type: 'iban' | 'paypal';
        version: number;
      },
    ) =>
      makeCall('PUT', `/api/v2/user/me/payout-method/${methodId}`, {
        data,
      }),
    /** @swagger /#api-Default-userUserIdPayoutMethodPayoutMethodIdDelete */
    removePayoutMethod: (methodId: number) =>
      makeCall('DELETE', `/api/v2/user/me/payout-method/${methodId}`),
    getFeatureFlags: () =>
      makeCall<{ features: {} }>('GET', `/api/v2/user/me/features`).then(
        ({ data }) => data.features,
      ),
    uploadAvatar: ({
      userId,
      avatar,
    }: {
      userId: 'me' | number;
      avatar: string;
    }) =>
      makeCall('PUT', `/api/v2/user/${userId}/avatar`, {
        data: { avatar },
        headers: {
          'Content-Type': 'multipart/form-data; boundary=%s',
        },
      }),
    updateListing: (id: number, data: {}) =>
      makeCall('PUT', `/api/v2/listing/${id}`, {
        data,
      }),
  };
};
